import {
  TagFragment,
  Button,
  Facts,
  Features,
  Glb,
  Iframe,
  Media,
  Press,
  Presses,
  PullQuote,
  Table,
  TeaserBlock,
  Video,
  VideoExternal
} from '~/graphql/fragments'
import { graphql } from '~/lib/datocms/graphql'

export const queryWork = graphql(
  /* GraphQL */ `
    query Work($slug: String) {
      work(filter: { slug: { eq: $slug } }) {
        _seoMetaTags {
          ...TagFragment
        }
        __typename
        _modelApiKey
        id
        createdAt
        clients {
          id
          name
          slug
        }
        category {
          __typename
          _modelApiKey
          id
          name
          slug
        }
        services {
          id
          title
          slug
        }
        overview
        body {
          blocks {
            ... on RecordInterface {
              id
              _modelApiKey
              __typename
            }
            ...Button
            ...Facts
            ...Features
            ...Iframe
            ...Glb
            ...Media
            ...Press
            ...Presses
            ...PullQuote
            ...Table
            ...TeaserBlock
            ...Video
            ...VideoExternal
          }
          links {
            ... on RecordInterface {
              id
              _modelApiKey
              __typename
            }
            ... on ArticleRecord {
              slug
              title
            }
            ... on PageRecord {
              title
              slug
            }
            ... on WorkRecord {
              slug
              title
            }
          }
          value
        }
        image {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "21:9", w: 1440 }
          ) {
            ...ResponsiveImage
          }
        }
        video {
          url
          mimeType
          video {
            duration
            framerate
            mp4Url(res: medium, exactRes: medium)
            thumbnailUrl
            streamingUrl
            muxPlaybackId
            muxAssetId
          }
        }
        videoLoop {
          url
          mimeType
          video {
            duration
            framerate
            mp4Url(res: medium, exactRes: medium)
            thumbnailUrl
            streamingUrl
            muxPlaybackId
            muxAssetId
          }
        }
        title
        slug
      }
    }
  `,
  [
    TagFragment,
    Button,
    Facts,
    Features,
    Glb,
    Iframe,
    Media,
    Press,
    Presses,
    PullQuote,
    Table,
    TeaserBlock,
    Video,
    VideoExternal
  ]
)
